import { useMemo, useState } from "react";

import { INITIAL_FORM_DATA } from "../constants";
import {
  FormData,
  NewProperty,
  NewTenant,
  PropertyLocal,
  SelectedLandlord,
  TenantInfo,
} from "../types";

export const useRentalApplicationForm = () => {
  const [formData, setFormData] = useState<FormData>(INITIAL_FORM_DATA);
  const [properties, setProperties] = useState<PropertyLocal[]>([]);
  const [newProperty, setNewProperty] = useState<NewProperty>({
    label: "",
    alias: "",
    direccion: "",
    colonia: "",
    uso: "industrial",
    rental_price: "",
    maintenance_price: "",
    street: "",
    exterior_number: "",
    interior_number: "",
    zip_code: "",
    municipality: "",
    city: "",
    state: "",
  });
  const [selectedLandlord, setSelectedLandlord] = useState<SelectedLandlord>(
    {},
  );
  const [newTenant, setNewTenant] = useState<NewTenant>({
    name: "",
    first_surname: "",
    second_surname: "",
    email: "",
    phone_number: "",
    dial_code: "+52",
    company_rfc: "",
    legal_entity_name: "",
  });
  const [tenants, setTenants] = useState<Record<string, TenantInfo>>({});

  const selectedProperty = useMemo(
    () => properties.find((p) => p.id === formData.property),
    [properties, formData.property],
  );

  const updateFormData = (field: string, value: any) =>
    setFormData((prev) => ({ ...prev, [field]: value }));

  const updateMultipleFormData = (updates: Partial<FormData>) =>
    setFormData((prev) => ({ ...prev, ...updates }));

  const resetForm = () => {
    setFormData(INITIAL_FORM_DATA);
  };

  const resetNewProperty = () => {
    setNewProperty({
      label: "",
      alias: "",
      direccion: "",
      colonia: "",
      uso: "industrial",
      rental_price: "",
      maintenance_price: "",
      street: "",
      exterior_number: "",
      interior_number: "",
      zip_code: "",
      municipality: "",
      city: "",
      state: "",
    });
  };

  const resetNewTenant = () => {
    setNewTenant({
      name: "",
      first_surname: "",
      second_surname: "",
      email: "",
      phone_number: "",
      dial_code: "+52",
      company_rfc: "",
      legal_entity_name: "",
    });
  };

  return {
    formData,
    updateFormData,
    updateMultipleFormData,
    resetForm,
    properties,
    setProperties,
    selectedProperty,
    newProperty,
    setNewProperty,
    resetNewProperty,
    selectedLandlord,
    setSelectedLandlord,
    newTenant,
    setNewTenant,
    tenants,
    resetNewTenant,
  };
};
